import React, { FC } from 'react';
import { Navigation } from 'router/Navigation';

export const App: FC = () => <Navigation />;
